import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, FunctionField, SimpleList } from 'react-admin';
import { vehicleSvgs, hideName, hideMobileNumber, hideVehicleNumber } from "./sharedData";
import { useMediaQuery, Avatar, makeStyles, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import CustomFilter from './components/CustomFilter';
import CustomSearch from './components/CustomSearch';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import queryString from 'query-string';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    }
});


const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 48 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

const renderBrand = row => row.brand ? row.brand : '-'
const renderModel = row => row.model ? row.model : '-'
const renderAmount = (row, fieldName) => (`₹ ${parseFloat(row[fieldName])}`);

export const ParkingSlotBookList = (props) => {

    const classes = useStyles()
    //const notify = useNotify()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();

    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Brand", "Model", "Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");

    let filterTypesInitState = [
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };


    const renderStatus = (record) => {
        if (!record.booking_status && record.end_time > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
            return { style: { color: "#e99100", backgroundColor: "#e9910019" }, value: { status: "Not Started" } }
        }
        else if (record.booking_status && record.booking_status === "Started" && record.end_time > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
            return { style: { color: "#109cf1", backgroundColor: "#109cf119" }, value: { status: "Inprogress" } }
        }
        else if (!record.booking_status && record.end_time < moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
            return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: `Expired` } }
        }
        else if (record.booking_status && record.booking_status === "Started" && record.end_time < moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
            return { style: { color: "#18cc69", backgroundColor: "#18cc6919" }, value: { status: `Completed` } }
        } else {
            return { style: { color: "#FFF", backgroundColor: "#FFF" }, value: { status: `-` } }
        }
    }

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            </div>
            {
            <div style={{ color: "#8097B1", fontSize: 12, marginTop: 10 }}>
                Showing Results for:{" "}
                {startDateTimeFilter && endDateTimeFilter ?
                    (`${moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a")} - ${moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a")}`)
                    :
                    (`${moment().format("MMM Do, YYYY")} 12:00 AM - 11:59 PM`)}
            </div>
        }
            <List {...props}
                style={{marginTop: 20}}
                empty={false}
                filter={filter}
                title="Parking Slot Booking"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination />} >

                {isSmallDevice ?
                    <SimpleList
                        leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
                        primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
                        secondaryText={record => (<div>
                            {record.brand && <div><span style={{ color: "#5a5a5a" }}>Brand: </span>{record.brand}</div>}
                            {record.model && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{record.model}</div>}
                            {record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile)}</div>}
                            {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹{parseFloat(record.amount)}</div>}
                            {record.start_time && <div><span style={{ color: "#5a5a5a" }}>Start Time: </span>{renderTime(record["start_time"])}</div>}
                            {record.end_time && <div><span style={{ color: "#5a5a5a" }}>End Time: </span>{renderTime(record["end_time"])}</div>}
                            {record.start_time && record.end_time && <div><span style={{ color: "#5a5a5a" }}>Duration: </span>{moment(record.end_time).to(record.start_time, true)}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Booked At: </span>{renderTime(record["created_on"])}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            <FunctionField
                                source="end_time"
                                label="Status"
                                render={record => {
                                    let recordResult = renderStatus(record)
                                    return <div style={{ margin: "6px 0px" }}>
                                        <div style={{ color: "#5a5a5a" }}>Status: <span style={{ ...recordResult.style, padding: "1px 8px", borderRadius: 500 }}>{recordResult.value.status}</span></div>
                                    </div>
                                }}
                            />
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <FunctionField
                            source="vehicle_type"
                            label="Type"
                            render={record => record && renderVehicleType(record)}
                            sortable
                        />
                        <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record["vehicle_number"] !== null ? hideVehicleNumber(record["vehicle_number"]) : "-"} />
                        <FunctionField
                            source="brand"
                            label="Brand"
                            render={record => record && renderBrand(record)}
                        /><FunctionField
                            source="model"
                            label="Model"
                            render={record => record && renderModel(record)}
                        />
                        <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
                        <FunctionField source="mobile" label="Mobile" render={record => record && record["mobile"] && record["mobile"] !== null ? hideMobileNumber(record.mobile): "-"} />
                        <FunctionField source="amount" label="Amount" render={(record) => record && renderAmount(record, "amount")} sortable={true} />
                        <FunctionField source="start_time" label="Start Time" render={record => record && renderTime(record["start_time"])} sortable={true} />
                        <FunctionField source="end_time" label="End Time" render={record => record && renderTime(record["end_time"])} sortable={true} />
                        <FunctionField label="Duration" render={record => record && moment(record.end_time).to(record.start_time, true)} sortable={true} />
                        <TextField source="parking_name" label="Parking Name" />
                        <FunctionField source="created_on" label="Booked At" render={record => record && renderTime(record["created_on"])} sortable={true} />
                        <FunctionField
                            source="end_time"
                            label="Status"
                            render={record => {
                                let recordResult = renderStatus(record)
                                return <div style={{ textAlign: "center" }}>
                                    <div
                                        className={classes.chipCell}
                                        style={{ ...recordResult.style, marginBottom: "5px" }}
                                    >
                                        {recordResult.value.status}
                                    </div>
                                </div>
                            }}
                            style={{ display: "flex", justifyContent: "center" }}
                        />

                    </Datagrid>
                }
            </List>
        </div>
    )
};
